import { render, staticRenderFns } from "./classes-import-student.vue?vue&type=template&id=4d323b45&scoped=true"
import script from "./classes-import-student.vue?vue&type=script&lang=ts"
export * from "./classes-import-student.vue?vue&type=script&lang=ts"
import style0 from "./classes-import-student.vue?vue&type=style&index=0&id=4d323b45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d323b45",
  null
  
)

export default component.exports